import React from "react";
import { icons, colors2, useScreenWidth, getBreakPoint } from "oolib";

const { grey40 } = colors2

export const genIcon = ({icon, weight="bold", disabled, S, color, className = '', size}) => {
  if (!icon) return null;
  const IconComp = icons[icon];
  if(!IconComp) return null;
  const screenWidth = useScreenWidth()
  const isMobile = screenWidth <= getBreakPoint("sm")

  return <IconComp
    className={className}
    size={size || isMobile ? 18 : 16} // mobile 18 and desktop 16
    style={{color: disabled ? grey40 : (color || undefined)}}
    weight={weight}
  />;
};
